import { render } from "./dictionary.vue?vue&type=template&id=128aeed2&scoped=true"
const script = {}

import "./dictionary.vue?vue&type=style&index=0&id=128aeed2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-128aeed2"]])

export default __exports__